(function () {
  // ---------------------------------------------------------------------
  // Top Products Slider: infinite loop + prev/next + dot pagination
  // Same loop technique as the collection banner slider: clone the real
  // slide set before/after the original, start scrolled into the middle,
  // and silently jump by one "third" when nearing either cloned edge.
  // Navigation is button-driven only (no click-and-drag); touch users can
  // still swipe since the track is a native horizontal scroll container.
  // Event delegation on document so it survives theme-editor re-renders.
  // ---------------------------------------------------------------------

  var LOOP_BUFFER_RATIO = 0.05;
  var LOOP_BUFFER_MIN = 20;

  function getStep(track) {
    var firstSlide = track.querySelector('.tp-slide');
    if (!firstSlide) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || 0) || 0;
    return firstSlide.getBoundingClientRect().width + gap;
  }

  function isLoopable(track) {
    return track.dataset.tpLoop === '1';
  }

  // ---- Loop setup ---------------------------------------------------------

  function cloneSlideSet(realSlides) {
    var frag = document.createDocumentFragment();
    realSlides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.classList.add('tp-slide--clone');
      clone.setAttribute('aria-hidden', 'true');
      var link = clone.querySelector('a');
      if (link) link.setAttribute('tabindex', '-1');
      frag.appendChild(clone);
    });
    return frag;
  }

  function initLoop(track, loopEnabled) {
    if (track.dataset.tpInit === '1') return;
    track.dataset.tpInit = '1';
    if (!loopEnabled) return;

    var realSlides = Array.prototype.slice.call(
      track.querySelectorAll('.tp-slide:not(.tp-slide--clone)')
    );
    if (realSlides.length < 2) return;

    track.insertBefore(cloneSlideSet(realSlides), track.firstChild);
    track.appendChild(cloneSlideSet(realSlides));
    track.dataset.tpLoop = '1';

    var prevBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var third = track.scrollWidth / 3;
        track.dataset.tpThird = String(third);
        track.scrollLeft = third;
        track.style.scrollBehavior = prevBehavior || '';
        updateDots(track);
      });
    });
  }

  function recalcThird(track) {
    var oldThird = parseFloat(track.dataset.tpThird || '0');
    var offsetIntoReal = oldThird > 0 ? track.scrollLeft - oldThird : 0;
    var newThird = track.scrollWidth / 3;
    track.dataset.tpThird = String(newThird);
    var prevBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = newThird + offsetIntoReal;
    track.style.scrollBehavior = prevBehavior || '';
  }

  function handleLoopBoundary(track) {
    if (!isLoopable(track)) return;
    var third = parseFloat(track.dataset.tpThird || '0');
    if (!third) return;

    var buffer = Math.max(LOOP_BUFFER_MIN, track.clientWidth * LOOP_BUFFER_RATIO);

    if (track.scrollLeft < buffer) {
      track.scrollLeft += third;
    } else if (track.scrollLeft > third * 2 - buffer) {
      track.scrollLeft -= third;
    }
  }

  // ---- Dot pagination -------------------------------------------------------

  function getVisibleCount(track) {
    var step = getStep(track);
    if (!step) return 1;
    return Math.max(1, Math.round(track.clientWidth / step));
  }

  function buildDots(track) {
    var section = track.closest('.tp-section');
    if (!section) return;
    var dotsEl = section.querySelector('[data-tp-dots]');
    if (!dotsEl) return;

    var realCount = track.querySelectorAll('.tp-slide:not(.tp-slide--clone)').length;
    var visibleCount = getVisibleCount(track);
    var totalPages = Math.max(1, Math.ceil(realCount / visibleCount));

    dotsEl.innerHTML = '';
    for (var i = 0; i < totalPages; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tp-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.dataset.tpPage = String(i);
      dotsEl.appendChild(dot);
    }
    track.dataset.tpVisibleCount = String(visibleCount);
    track.dataset.tpTotalPages = String(totalPages);
    updateDots(track);
  }

  function updateDots(track) {
    var section = track.closest('.tp-section');
    if (!section) return;
    var dotsEl = section.querySelector('[data-tp-dots]');
    if (!dotsEl) return;
    var dots = dotsEl.querySelectorAll('.tp-dot');
    if (!dots.length) return;

    var third = parseFloat(track.dataset.tpThird || '0');
    var visibleCount = parseFloat(track.dataset.tpVisibleCount || '1');
    var step = getStep(track);
    var pageWidth = step * visibleCount;
    if (!pageWidth) return;

    var posInReal = third ? track.scrollLeft - third : track.scrollLeft;
    var realWidth = third || track.scrollWidth;
    // wrap into [0, realWidth)
    posInReal = ((posInReal % realWidth) + realWidth) % realWidth;

    var activeIndex = Math.round(posInReal / pageWidth) % dots.length;

    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === activeIndex);
    });
  }

  // ---- Quick add to cart ------------------------------------------------------

  function setQuickAddState(btn, state) {
    btn.classList.remove('is-loading', 'is-added', 'is-error');
    if (state) btn.classList.add(state);
    var labelAttr = {
      idle: 'data-add-label',
      loading: 'data-adding-label',
      added: 'data-added-label',
      error: 'data-error-label'
    }[state || 'idle'];
    var label = btn.getAttribute(labelAttr);
    if (label) btn.textContent = label;
  }

  function quickAddToCart(btn) {
    if (btn.classList.contains('is-loading')) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    setQuickAddState(btn, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function () {
        setQuickAddState(btn, 'added');
        // Let the theme's cart drawer/icon bubble know something changed.
        // If your theme listens for a different event (e.g. Dawn's
        // "cart:refresh" or a custom cart-drawer render call), swap it in here.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          setQuickAddState(btn, 'idle');
        }, 1800);
      })
      .catch(function (err) {
        setQuickAddState(btn, 'error');
        setTimeout(function () {
          setQuickAddState(btn, 'idle');
        }, 1800);
        console.error('Quick add to cart failed', err);
      });
  }

  // ---- Init / wiring ---------------------------------------------------------

  function initTrack(track) {
    var section = track.closest('.tp-section');
    var loopEnabled = section ? section.dataset.loop !== 'false' : true;
    initLoop(track, loopEnabled);
    buildDots(track);
  }

  function initAllTracks() {
    document.querySelectorAll('.tp-track').forEach(initTrack);
  }

  document.addEventListener('click', function (event) {
    var quickAddBtn = event.target.closest('[data-tp-quick-add]');
    if (quickAddBtn) {
      event.preventDefault();
      event.stopPropagation();
      quickAddToCart(quickAddBtn);
      return;
    }

    var navBtn = event.target.closest('.tp-nav--prev, .tp-nav--next');
    if (navBtn) {
      var section = navBtn.closest('.tp-section');
      if (!section) return;
      var track = section.querySelector('.tp-track');
      if (!track) return;
      var direction = navBtn.classList.contains('tp-nav--prev') ? -1 : 1;
      track.scrollBy({ left: direction * getStep(track), behavior: 'smooth' });
      return;
    }

    var dot = event.target.closest('.tp-dot');
    if (dot) {
      var dotsEl = dot.closest('[data-tp-dots]');
      var sectionEl = dotsEl ? dotsEl.closest('.tp-section') : null;
      var dotTrack = sectionEl ? sectionEl.querySelector('.tp-track') : null;
      if (!dotTrack) return;
      var pageIndex = parseInt(dot.dataset.tpPage, 10) || 0;
      var pgStep = getStep(dotTrack);
      var visibleCount = parseFloat(dotTrack.dataset.tpVisibleCount || '1');
      var pageWidth = pgStep * visibleCount;
      var third = parseFloat(dotTrack.dataset.tpThird || '0');
      var target = (third || 0) + pageIndex * pageWidth;
      dotTrack.scrollTo({ left: target, behavior: 'smooth' });
    }
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target && target.classList && target.classList.contains('tp-track')) {
        handleLoopBoundary(target);
        updateDots(target);
      }
    },
    { passive: true, capture: true }
  );

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.tp-track').forEach(function (track) {
        if (isLoopable(track)) recalcThird(track);
        buildDots(track);
      });
    }, 150);
  });

  document.addEventListener('DOMContentLoaded', initAllTracks);
  document.addEventListener('shopify:section:load', initAllTracks);
})();
